import { useSnapshot } from "valtio"
import { editStore } from "./editStore"
import Utils from "../util/Utils"
import { useState } from "react";
import { useRef } from "react";
import TenantUtils from "../util/tenant.utils";
import { dataListStore } from "../state/CommonState";
import Api from "../state/Api";
import { enquiryStore } from "../enquiry/enquiry-data";
import { useMobile } from "../hooks/usemobile";
import EntityV2Api from "../state/entities-api";

export default function CopyMail(props) {
    let setOpenCopyMail = props.setOpenCopyMail
    const [copied,setCopied] = useState(false)
    const [view,setView] = useState("Detailed")
    const [showView,setShowView] = useState(false)
    const [expandedRemarks, setExpandedRemarks] = useState({});
    const copyRef = useRef(null);
    const copyRef1 = useRef(null);
    const rateRequestPending = useRef(false);
    // Raise a rate request on copy: non-FCL always, FCL only for imports
    const raiseRateRequest = async () => {
        if (enquiryStore.rateRequestlist.length !== 0 || rateRequestPending.current) return;
        rateRequestPending.current = true;
        try {
            const shipmentType = editStore.pricingRec.dummyContract.shipmentType || "";
            if (shipmentType.indexOf("FCL") !== -1) {
                const entityId = enquiryStore.current?.entityId;
                if (!entityId) return;
                const entity = await EntityV2Api.viewEntity(entityId);
                const tradeType = Utils.getTradeType({
                    rec: enquiryStore.current,
                    shipmentType,
                    entityCountry: entity?.entityCountry
                });
                if (tradeType !== "Import") return;
            }
            enquiryStore.rateRequestlist.push({});
            Api.saveQuoteNoTransform(editStore.pricingRec, false, false, true, () => {
                enquiryStore.checkRateRequest = !enquiryStore.checkRateRequest;
            });
        } finally {
            rateRequestPending.current = false;
        }
    };
    const isMobile = useMobile();
    useSnapshot(editStore)
    useSnapshot(dataListStore);

    const toggleRemarks = (e, idx) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setExpandedRemarks(prev => ({
            ...prev,
            [idx]: !prev[idx]
        }));
    };

    const prjs = (d)=>{
        return JSON.parse(JSON.stringify(d))
    }
    const Card = ({ pricingRec, copiedOceanFreight, id })=>{
        let rec = pricingRec
        let origin = rec.dummyContract.origin
        let destination = rec.dummyContract.destination
        let pod = rec.pod
        let fpod = rec.fpod
        let rep = rec.rep
        let shipmentType = rec.dummyContract.shipmentType
        let validtill = Utils.ddmmyyyy(new Date(rec.dummyContract.validUpto))
        let VesselName =""
        let VoyageNumber = ""
        let ETDDate = ""
        let agentAddress = ""
        let agentDetails = ""
        let carrier = ""
        let transitTime = 0
        let schedules = []
        let tc = []
        if(rec.dummyContract.schedules!=undefined){
            schedules = rec.dummyContract.schedules
        }
        if(rec.quote.agentAddress!=undefined){
            agentAddress = TenantUtils.changeagent(rec.quote.agentAddress)
        }
        if(rec.quote.agentDetails!=undefined){
            agentDetails = TenantUtils.changeagent(rec.quote.agentDetails)
        }
        if(rec.quote.tc!=undefined){
            tc = rec.quote.tc
        }
        if(rec.quote.customTerms!=undefined){
            tc = tc.concat(rec.quote.customTerms)
        }
        let chargelist = []
        chargelist = chargelist.concat(rec.dummyContract.chargesList)
        chargelist = chargelist.concat(rec.dummyContract.consigneechargesList)
        chargelist = chargelist.concat(rec.dummyContract.shipperchargesList)
        for (let i = 0; i < chargelist.length; i++) {
                let existingRemarks = chargelist[i]['remarks'] || "";
                if(pricingRec['charges'] && pricingRec['charges'][chargelist[i]['chargeDescription']]!=undefined){
                    let charge = pricingRec['charges'][chargelist[i]['chargeDescription']];
                    if(!existingRemarks && charge?.remarks){
                        existingRemarks = charge.remarks;
                    }
                    if(!existingRemarks && charge?.template?.remarks){
                        existingRemarks = charge.template.remarks;
                    }
                }
                chargelist[i]['remarks'] = existingRemarks;
        }
        let perchargelable = ""
        let Ocean_Freight_amount = 0
        let Ocean_Freight_currency = "USD"
        if(shipmentType.indexOf("FCL")!=-1){
            if(rec.scac!=undefined && rec.scac.length>0){
                for (let i = 0; i < dataListStore["FCLCarrierList"].length; i++) {
                    let l = dataListStore["FCLCarrierList"][i]
                    if(l["SCAC code"] == rec.scac){
                        carrier = `${l["Display Name"]} (${l["SCAC code"]})`
                        i = dataListStore["FCLCarrierList"].length+1
                    }
                }
            }
            
            if(schedules.length>0){
                let s = schedules[0]
                if(s['ts1name']!=undefined){
                    rep = s['ts1name']
                }
                if(s['transitTime']!=undefined && Utils.toNum(s['transitTime'])>0){
                    transitTime = Utils.toNum(s['transitTime'])
                }
            }
            if(transitTime==0){
                if (rec?.charges?.['Ocean Freight']?.template?.transitTime !== undefined) {
                    transitTime = Utils.toNum(rec.charges['Ocean Freight'].template.transitTime)
                }
            }
            for (let i = 0; i < chargelist.length; i++) {
                if(chargelist[i]['chargeDescription']=='Ocean Freight'){
                    let k = Object.keys(chargelist[i])
                    for (let j = 0; j < k.length; j++) {
                        if(k[j].indexOf("perWM")!=-1){
                            perchargelable = k[j].split('perWM')[0]
                            Ocean_Freight_amount = chargelist[i][k[j]]
                            Ocean_Freight_currency = chargelist[i]['currency']
                            j = k.length+1
                        }
                    }
                }
            }
        }
        const getRouting = (ReWorkingPortName, POD, FPOD)=> {
            const routing = ReWorkingPortName!=undefined && ReWorkingPortName.length>0 ? ReWorkingPortName : POD;
            if (routing !== FPOD) {
                return `${routing}`;
            } else {
                return `Direct`;
            }
        }
        let routing = getRouting(rep,pod,fpod)
        const convertCharges=(charges)=> {
            return charges.map(item => {
                const curr = item.currency;
                const cbm = item.perCBM || 0;
                const ton = item.perTon || 0;
                const min = item.minimum || 0;
                const max = item.maximum || 0;
                const perBL = item.perShipment || 0;

                let CH = "";
                let displayLogic = "";

                const hasCBM = cbm != 0;
                const hasTon = ton != 0;
                const cbmEqualsTon = hasCBM && hasTon && cbm === ton;

                if (perBL != 0 && min === 0 && max != 0 && !hasCBM && !hasTon) {
                    CH = "CH9";
                }
                else if (perBL != 0 && min != 0 && max === 0 && !hasCBM && !hasTon) {
                    CH = "CH8";
                }
                else if (perBL != 0 && min === 0 && max === 0 && !hasCBM && !hasTon) {
                    CH = "CH7";
                }
                else if (hasCBM && hasTon && min === 0 && max === 0) {
                    CH = "CH1";
                }
                else if (hasCBM && !hasTon) {
                    CH = "CH2";
                }
                else if (!hasCBM && hasTon) {
                    CH = "CH3";
                }
                else if (hasCBM && hasTon && min > 0 && max === 0) {
                    CH = "CH4";
                }
                else if (hasCBM && hasTon && min != 0 && max != 0) {
                    CH = "CH5";
                }
                else if (hasCBM && hasTon && min === 0 && max != 0) {
                    CH = "CH6";
                }
                else {
                    CH = "CH1";
                }

                let wmLogic = "";

                if (hasCBM || hasTon) {
                    if (cbmEqualsTon) {
                        wmLogic = `${Utils.N(cbm, curr)} Per W/M`;
                    } 
                    else if (hasCBM && hasTon) {
                        wmLogic = `${Utils.N(cbm, curr)} Per CBM OR ${Utils.N(ton, curr)} Per Ton`;
                    } 
                    else if (hasCBM) {
                        wmLogic = `${Utils.N(cbm, curr)} Per CBM`;
                    } 
                    else {
                        wmLogic = `${Utils.N(ton, curr)} Per Ton`;
                    }
                }

                switch (CH) {
                    case "CH1":
                    case "CH2":
                    case "CH3":
                        displayLogic = wmLogic;
                        if (perBL !== 0) {
                            displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                        }
                        break;
                    case "CH4":
                        displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)}`;
                        break;
                    case "CH5":
                        displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)} AND Maximum ${Utils.N(max, curr)}`;
                        break;
                    case "CH6":
                        displayLogic = `${wmLogic}, Maximum ${Utils.N(max, curr)}`;
                        break;
                    case "CH7":
                        displayLogic = `${Utils.N(perBL, curr)} Per Bill of Lading`;
                        if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
                        break;
                    case "CH8":
                        displayLogic = `${Utils.N(min, curr)} Minimum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                        if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
                        break;
                    case "CH9":
                        displayLogic = `${Utils.N(max, curr)} Maximum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                        if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
                        break;
                }
                if(displayLogic.indexOf('Per Bill of Lading')==-1){
                    if(perBL != 0){
                        displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                    }
                }
                

                return {
                    chargeDescription: item.chargeDescription,
                    remarks:item.remarks || "",
                    CH,
                    currency: curr,
                    perCBM: cbm || null,
                    perTon: ton || null,
                    minimum: min || null,
                    maximum: max || null,
                    perBL: perBL || null,
                    displayLogic
                };
            });
        }
        const convertChargesfcl=(containerList,charges)=> {
            let l = []
            containerList.map(e=>{
                let ct = e.containerType
                return charges.map(item => {
                    const curr = item.currency;
                    const perWM = item[ct+"perWM"] || 0;
                    const perShipment = item[ct+"perShipment"] || 0;

                    let CH = "";
                    let displayLogic = "";

                    const hasPerWM = perWM != 0;
                    const hasPerShipment = perShipment != 0;
                    const PerWMHavePerShipment = hasPerWM && hasPerShipment;

                    if (PerWMHavePerShipment) {
                        CH = "CH1";
                    }
                    else if (hasPerWM) {
                        CH = "CH2";
                    }
                    else if (hasPerShipment) {
                        CH = "CH3";
                    }

                    switch (CH) {
                        case "CH1":
                            displayLogic = `${Utils.N(perWM,curr)}  Per Container AND ${Utils.N(perShipment,curr)} Per BL`;
                            break;
                        case "CH2":
                            displayLogic = `${Utils.N(perWM,curr)}  Per Container`;
                            break;
                        case "CH3":
                            displayLogic = `${Utils.N(perShipment,curr)} Per BL`;
                            break;
                    }

                    l.push({
                        chargeDescription: item.chargeDescription+" - "+ct,
                        remarks: item.remarks || "",
                        CH,
                        currency: curr,
                        perWM: perWM || null,
                        perShipment: perShipment || null,
                        displayLogic
                    });
                });
            })
            return l
        }
        let origincharges = []
        let oceanFreightcharges = []
        let Destinationcharges = []
        let DestinationDescription = []
        for (let i = 0; i < chargelist.length; i++) {
            let c = chargelist[i]
            if(c && c['chargeDescription']!=undefined){
                let d = c['chargeDescription']
                let cat = (c['category'] || '').toUpperCase()

                if(cat === 'ORIGIN'){
                    d = d.replace('Origin Charges - ','')
                    d = d.replace('Origin - ','')
                    d = d.replace('Origin Charges','')
                    d = d.replace('Origin','')
                    chargelist[i]['chargeDescription'] = d
                    origincharges.push(chargelist[i])
                }
                else if(cat === 'DESTINATION'){
                    d = d.replace('Destination Charges - ','')
                    d = d.replace('Destination - ','')
                    d = d.replace('Destination Charges','')
                    d = d.replace('Destination','')
                    chargelist[i]['chargeDescription'] = d
                    if(d.length>0){
                        DestinationDescription.push(d)
                    }
                    Destinationcharges.push(chargelist[i])
                }
                else if(cat === 'FREIGHT' || cat === 'OCEAN FREIGHT'){
                    oceanFreightcharges.push(chargelist[i])
                }
            }
        }
        let Destinationchargestotal = {chargeDescription:"Destination",perCBM:0,
                    perTon: 0,
                    minimum: 0,
                    maximum: 0,
                    perBL: 0,
                currency:"INR"}
        if(shipmentType.indexOf("FCL")!=-1){
            origincharges = convertChargesfcl(rec.dummyContract.containerList,origincharges)
            oceanFreightcharges = convertChargesfcl(rec.dummyContract.containerList,oceanFreightcharges)
            Destinationcharges = convertChargesfcl(rec.dummyContract.containerList,Destinationcharges)
        }else{
        for (let i = 0; i < Destinationcharges.length; i++) {
            let d = Destinationcharges[i]
            Destinationchargestotal['currency']=Destinationcharges[0]['currency']
            let k = ["perCBM","perTon", "minimum","maximum","perBL"]
            k.map((e)=>{
                if(d[e]!=undefined && d[e]){
                    Destinationchargestotal[e] = Destinationchargestotal[e]+Number(d[e])
                }
            })
        }
        
        origincharges = convertCharges(origincharges)
        oceanFreightcharges = convertCharges(oceanFreightcharges)
        if(Destinationcharges.length>0){
            Destinationchargestotal = convertCharges([Destinationchargestotal])
            Destinationcharges = convertCharges(Destinationcharges)
        }
    }

        if (isMobile) {
            return (
                <div id={id} key={id} style={copiedOceanFreight ? {
                    position: "absolute",
                    left: "-9999px",
                    top: 0,
                    width: "800px"
                } : {}}>
                    <div ref={!copiedOceanFreight ? copyRef : copyRef1} style={{
                        backgroundColor: "#fff",
                        borderRadius: "0.5rem",
                        color: "#334155",
                        maxWidth: "100%",
                        position: "relative",
                        // padding: "12px"
                    }}>
                        {/* Route Box */}
                        <div style={{
                            backgroundColor: "#ffffff",
                            border: "1px solid #e2e8f0",
                            borderRadius: "10px",
                            padding: "12px 14px",
                            marginBottom: "12px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                        }}>
                            <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", marginBottom: "8px" }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "4px" }}>
                                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#2563eb" }} />
                                    <div style={{ width: "2px", height: "28px", backgroundColor: "#cbd5e1", margin: "3px 0" }} />
                                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#64748b" }} />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                        ORIGIN
                                    </div>
                                    <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a", marginBottom: "8px" }}>
                                        {origin}
                                    </div>

                                    <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                        DESTINATION
                                    </div>
                                    <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a" }}>
                                        {destination}
                                    </div>
                                </div>
                            </div>

                            <div style={{
                                display: "inline-flex",
                                alignItems: "center",
                                backgroundColor: "#f1f5f9",
                                borderRadius: "6px",
                                padding: "4px 10px",
                                fontSize: "12px",
                                marginTop: "4px"
                            }}>
                                <span style={{ color: "#64748b", fontWeight: "500", marginRight: "4px" }}>Routing:</span>
                                <span style={{ color: "#0f172a", fontWeight: "700" }}>{routing}</span>
                            </div>

                            {shipmentType.indexOf("FCL") !== -1 && (
                                <div style={{ marginTop: "8px", paddingTop: "8px", borderTop: "1px dashed #e2e8f0", fontSize: "12px", color: "#475569" }}>
                                    {validtill && <div><strong>Valid Till:</strong> {validtill}</div>}
                                    {carrier.length > 0 && <div><strong>Carrier:</strong> {carrier}</div>}
                                    {transitTime > 0 && <div><strong>Ocean Transit Time:</strong> {transitTime}</div>}
                                    {Ocean_Freight_amount > 0 && <div><strong>Ocean Freight (Per Container):</strong> {Utils.N(Ocean_Freight_amount, Ocean_Freight_currency)} per {perchargelable}</div>}
                                </div>
                            )}
                        </div>

                        {showView && (
                            <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
                                <button
                                    type="button"
                                    style={{
                                        backgroundColor: view == "Summary" ? "#48c78e" : (process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON || "#2563eb"),
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "6px 14px",
                                        fontSize: "12px",
                                        fontWeight: "600"
                                    }}
                                    onClick={(e) => { e.preventDefault(); setView("Summary"); }}
                                >
                                    Summary
                                </button>
                                <button
                                    type="button"
                                    style={{
                                        backgroundColor: view == "Detailed" ? "#48c78e" : (process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON || "#2563eb"),
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "6px 14px",
                                        fontSize: "12px",
                                        fontWeight: "600"
                                    }}
                                    onClick={(e) => { e.preventDefault(); setView("Detailed"); }}
                                >
                                    Detailed
                                </button>
                            </div>
                        )}

                        {/* Ocean Freight */}
                        {oceanFreightcharges.length > 0 && (
                            <div style={{ marginBottom: "12px" }}>
                                <div style={{
                                    backgroundColor: "#dbeafe",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    color: "#1e3a8a",
                                    marginBottom: "8px"
                                }}>
                                    Ocean Freight
                                </div>
                                {oceanFreightcharges.map((e, idx) => (
                                    <div key={idx} style={{
                                        backgroundColor: "#ffffff",
                                        border: "1px solid #e2e8f0",
                                        borderRadius: "6px",
                                        padding: "10px 12px",
                                        marginBottom: "6px"
                                    }}>
                                        <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a" }}>
                                            {e.chargeDescription}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#64748b", marginTop: "3px" }}>
                                            {e.displayLogic}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Origin Charges */}
                        {!copiedOceanFreight && origincharges.length > 0 && (
                            <div style={{ marginBottom: "12px" }}>
                                <div style={{
                                    backgroundColor: "#dbeafe",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    color: "#1e3a8a",
                                    marginBottom: "8px"
                                }}>
                                    Origin Charges
                                </div>
                                {origincharges.map((e, idx) => (
                                    <div key={idx} style={{
                                        backgroundColor: idx % 2 === 1 ? "#f8fafc" : "#ffffff",
                                        border: "1px solid #e2e8f0",
                                        borderRadius: "6px",
                                        padding: "10px 12px",
                                        marginBottom: "6px"
                                    }}>
                                        <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a" }}>
                                            {e.chargeDescription}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#64748b", marginTop: "3px" }}>
                                            {e.displayLogic}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Destination Charges */}
                        {view == "Detailed" && !copiedOceanFreight && Destinationcharges.length > 0 && (
                            <div style={{ marginBottom: "12px" }}>
                                <div style={{
                                    backgroundColor: "#dbeafe",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    color: "#1e3a8a",
                                    marginBottom: "8px"
                                }}>
                                    Destination Charges
                                </div>
                                {Destinationcharges.map((e, idx) => {
                                    const hasRemarks = e.remarks && String(e.remarks).trim().length > 0;
                                    const isExpanded = !!expandedRemarks[idx];

                                    return (
                                        <div key={idx} style={{
                                            backgroundColor: idx % 2 === 1 ? "#f8fafc" : "#ffffff",
                                            border: "1px solid #e2e8f0",
                                            borderRadius: "6px",
                                            padding: "10px 12px",
                                            marginBottom: "6px"
                                        }}>
                                            <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a" }}>
                                                {e.chargeDescription}
                                            </div>
                                            <div style={{ fontSize: "12px", color: "#64748b", marginTop: "3px" }}>
                                                {e.displayLogic}
                                            </div>

                                            {hasRemarks && (
                                                <div style={{ marginTop: "8px" }}>
                                                    {!isExpanded ? (
                                                        <button
                                                            type="button"
                                                            onClick={(evt) => toggleRemarks(evt, idx)}
                                                            style={{
                                                                backgroundColor: "#38bdf8",
                                                                color: "#ffffff",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                padding: "4px 10px",
                                                                fontSize: "11px",
                                                                fontWeight: "600",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            See remarks
                                                        </button>
                                                    ) : (
                                                        <div
                                                            onClick={(evt) => toggleRemarks(evt, idx)}
                                                            style={{
                                                                backgroundColor: "#fef2f2",
                                                                border: "1px solid #fca5a5",
                                                                borderRadius: "6px",
                                                                padding: "8px 10px",
                                                                fontSize: "11px",
                                                                color: "#dc2626",
                                                                lineHeight: "1.4",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <strong>Remarks:</strong> {e.remarks}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {view == "Summary" && !copiedOceanFreight && Destinationcharges.length > 0 && (
                            <div style={{ marginBottom: "12px" }}>
                                <div style={{
                                    backgroundColor: "#dbeafe",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    color: "#1e3a8a",
                                    marginBottom: "8px"
                                }}>
                                    Destination Charges - Summary
                                </div>
                                <div style={{
                                    backgroundColor: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "6px",
                                    padding: "10px 12px",
                                    fontSize: "12px",
                                    color: "#334155"
                                }}>
                                    <div><strong>Destination Charges Total:</strong> {Destinationchargestotal[0]?.displayLogic}</div>
                                    {DestinationDescription.length > 0 && (
                                        <div style={{ marginTop: "4px", color: "#64748b" }}>Inclusive of {DestinationDescription.join(", ")}</div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Agent Details */}
                        {(agentDetails.length > 0 || agentAddress.length > 0) && (
                            <div style={{ marginBottom: "12px" }}>
                                <div style={{
                                    backgroundColor: "#dbeafe",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    color: "#1e3a8a",
                                    marginBottom: "8px"
                                }}>
                                    Agent Details
                                </div>
                                <div style={{ fontSize: "12px", color: "#334155", padding: "0 4px" }}>
                                    {agentDetails.length > 0 && <div><strong>Agent Name:</strong> {agentDetails}</div>}
                                    {agentAddress.length > 0 && <div><strong>Agent Contact:</strong> {agentAddress}</div>}
                                </div>
                            </div>
                        )}

                        {/* Terms & Conditions */}
                        {!copiedOceanFreight && tc.length > 0 && (
                            <div style={{ marginTop: "12px" }}>
                                <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a", marginBottom: "6px" }}>
                                    Terms & Conditions
                                </div>
                                <ul style={{ paddingLeft: "18px", fontSize: "12px", color: "#475569", margin: 0 }}>
                                    {tc.map((e, i) => (
                                        <li key={i} style={{ marginBottom: "3px" }}>{i + 1}. {e}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {copiedOceanFreight && (
                            <div style={{ marginTop: "12px" }}>
                                <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a", marginBottom: "6px" }}>
                                    Terms & Conditions
                                </div>
                                <ul style={{ paddingLeft: "18px", fontSize: "12px", color: "#475569", margin: 0 }}>
                                    <li style={{ marginBottom: "3px" }}>Destination Charges are at Actual.</li>
                                    <li style={{ marginBottom: "3px" }}>Destination CFS Charges are at actuals.</li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return <>
        <div id={id} key={id} style={copiedOceanFreight? {
          position: "absolute",
          left: "-9999px",
          top: 0,
          width: "800px"
        }:{}}><div  ref={!copiedOceanFreight?copyRef:copyRef1} style={{
    backgroundColor: "#fff",
    borderRadius: ".25rem",
    boxShadow: "0 .5em 1em -.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02)",
    color: "#4a4a4a",
    maxWidth: "100%",
    position: "relative",
    padding:"15px"
    
}}>
    <p><strong>Origin</strong> : {origin}</p>
    <p><strong>Destination</strong> : {destination}</p>
    <p><strong>Routing</strong> : {routing}</p>
    {shipmentType.indexOf("FCL")!=-1 && <p><strong>Valid Till</strong> : {validtill}</p>}
    {(shipmentType.indexOf("FCL")!=-1 && carrier.length>0) && <p><strong>Carrier</strong> : {carrier}</p>}
    {(shipmentType.indexOf("FCL")!=-1 && transitTime>0) && <p><strong>Ocean Transit Time</strong> : {transitTime}</p>}
    {shipmentType.indexOf("FCL")!=-1 && <p><strong>Ocean Freight (Per Container):</strong> : {Utils.N(Ocean_Freight_amount,Ocean_Freight_currency)} per {perchargelable}</p>}
    {showView && <div className="columns is-vcentered is-multiline">
        <div className="column is-12" style={{textAlign:"left"}}>
            <div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div className="control">
                        <button
                        className="button"
                        style={{
                          backgroundColor: view=="Summary"?"#48c78e":process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          if(view!="Summary"){
                            setView("Summary")
                          }
                        }}
                      >
                         Summary
                      </button>
                    </div>
                    <div className="control">
                        <button
                        className="button"
                        style={{
                          backgroundColor:view=="Detailed"?"#48c78e":process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          if(view!="Detailed"){
                            setView("Detailed")
                          }
                        }}
                      >
                        Detailed
                      </button>
                    </div>
                  </div>
        </div>
    </div>}
    {
        oceanFreightcharges.length>0 && <>
        <p><strong><u>Ocean Freight</u></strong></p>
        <div className="table-container">
                                    <table className="table" style={{ width:"100%"}}>
                    <thead>
                            <tr>
                                <th>Charge Description</th>
                                <th>Charges</th>
                                </tr></thead>
                                <tbody>
                                    {
                                        oceanFreightcharges.map((e)=>{
                                            return <tr>
                                                <td>{e.chargeDescription}</td>
                                                <td>{e.displayLogic}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                                </table></div>
        </>
    }
    {
        !copiedOceanFreight && origincharges.length>0 && <>
        <p><strong><u>Origin Charges</u></strong></p>
        <div className="table-container">
                                    <table className="table" style={{ width:"100%"}}>
                    <thead>
                            <tr>
                                <th>Charge Description</th>
                                <th>Charges</th>
                                </tr></thead>
                                <tbody>
                                    {
                                        origincharges.map((e)=>{
                                            return <tr>
                                                <td>{e.chargeDescription}</td>
                                                <td>{e.displayLogic}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                                </table></div>
        </>
    }
    {view=="Detailed" && <>{
        !copiedOceanFreight && Destinationcharges.length>0 && <>
        <p><strong><u>Destination Charges</u></strong></p>
        <div className="table-container">
                                    <table className="table" style={{ width:"100%"}}>
                    <thead>
                            <tr>
                                <th>Charge Description</th>
                                <th>Charges</th>
                                <th>Remarks</th>
                                </tr></thead>
                                <tbody>
                                    {
                                        Destinationcharges.map((e)=>{
                                            return <tr>
                                                <td>{e.chargeDescription}</td>
                                                <td>{e.displayLogic}</td>
                                                <td>{e.remarks}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                                </table></div>
        </>
    }</>}
    {view=="Summary" && <>{
        !copiedOceanFreight && Destinationcharges.length>0 && <>
        <p><strong><u>Destination Charges - Summary</u></strong></p>
        <p><strong>Destination Charges Total</strong> : {Destinationchargestotal[0].displayLogic}</p>
        {DestinationDescription.length>0 && <>{"Inclusive of "+DestinationDescription.join(", ")}</>}
        </>}</>}
    {(agentDetails.length>0 || agentAddress.length>0) && <p><strong><u>Agent Details</u></strong></p>}
    {agentDetails.length>0 && <p><strong>Agent Name</strong> : {agentDetails}</p>}
    {agentAddress.length>0 && <p><strong>Agent Contact</strong> : {agentAddress}</p>}
    {
        !copiedOceanFreight && tc.length>0 && <>
        <p>
            <strong><u>Terms & Conditions</u></strong>
        </p>
        <ul>
            {
                tc.map((e,i)=>{
                    return <li>{i+1}. {e}</li>
                })
            }
        </ul>
        </>
    }
     {
        copiedOceanFreight && <>
        <p>
            <strong><u>Terms & Conditions</u></strong>
        </p>
        <ul>
            <li>Destination Charges are at Actual.</li>
            <li>Destination CFS Charges are at actuals.</li>
            </ul>
        </>
     }
</div>
        
        </div></>
    }

    const copyTextToClipboard = async (text) => {
        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(text);
                return true;
            } catch (err) {
                console.error("Clipboard API failed: ", err);
            }
        }
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        textArea.style.top = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand("copy");
            textArea.remove();
            return true;
        } catch (err) {
            console.error("Fallback copy failed: ", err);
            textArea.remove();
            return false;
        }
    };

    const buildMobileCopyText = (pricingRec, copiedOceanFreight, viewMode = "Detailed") => {
        let rec = pricingRec;
        if (!rec || !rec.dummyContract) return "";

        let origin = rec.dummyContract.origin || "";
        let destination = rec.dummyContract.destination || "";
        let pod = rec.pod;
        let fpod = rec.fpod;
        let rep = rec.rep;
        let shipmentType = rec.dummyContract.shipmentType || "";
        let validtill = rec.dummyContract.validUpto ? Utils.ddmmyyyy(new Date(rec.dummyContract.validUpto)) : "";
        let agentAddress = "";
        let agentDetails = "";
        let carrier = "";
        let transitTime = 0;
        let schedules = [];
        let tc = [];

        if (rec.dummyContract.schedules != undefined) {
            schedules = rec.dummyContract.schedules;
        }
        if (rec.quote?.agentAddress != undefined) {
            agentAddress = TenantUtils.changeagent(rec.quote.agentAddress);
        }
        if (rec.quote?.agentDetails != undefined) {
            agentDetails = TenantUtils.changeagent(rec.quote.agentDetails);
        }
        if (rec.quote?.tc != undefined) {
            tc = rec.quote.tc;
        }
        if (rec.quote?.customTerms != undefined) {
            tc = tc.concat(rec.quote.customTerms);
        }

        let chargelist = [];
        if (rec.dummyContract.chargesList) chargelist = chargelist.concat(rec.dummyContract.chargesList);
        if (rec.dummyContract.consigneechargesList) chargelist = chargelist.concat(rec.dummyContract.consigneechargesList);
        if (rec.dummyContract.shipperchargesList) chargelist = chargelist.concat(rec.dummyContract.shipperchargesList);

        for (let i = 0; i < chargelist.length; i++) {
            let existingRemarks = chargelist[i]['remarks'] || "";
            if (pricingRec['charges'] && pricingRec['charges'][chargelist[i]['chargeDescription']] != undefined) {
                let charge = pricingRec['charges'][chargelist[i]['chargeDescription']];
                if (!existingRemarks && charge?.remarks) {
                    existingRemarks = charge.remarks;
                }
                if (!existingRemarks && charge?.template?.remarks) {
                    existingRemarks = charge.template.remarks;
                }
            }
            chargelist[i]['remarks'] = existingRemarks;
        }

        let perchargelable = "";
        let Ocean_Freight_amount = 0;
        let Ocean_Freight_currency = "USD";

        if (shipmentType.indexOf("FCL") != -1) {
            if (rec.scac != undefined && rec.scac.length > 0 && dataListStore["FCLCarrierList"]) {
                for (let i = 0; i < dataListStore["FCLCarrierList"].length; i++) {
                    let l = dataListStore["FCLCarrierList"][i];
                    if (l["SCAC code"] == rec.scac) {
                        carrier = `${l["Display Name"]} (${l["SCAC code"]})`;
                        break;
                    }
                }
            }

            if (schedules.length > 0) {
                let s = schedules[0];
                if (s['ts1name'] != undefined) {
                    rep = s['ts1name'];
                }
                if (s['transitTime'] != undefined && Utils.toNum(s['transitTime']) > 0) {
                    transitTime = Utils.toNum(s['transitTime']);
                }
            }
            if (transitTime == 0) {
                if (rec?.charges?.['Ocean Freight']?.template?.transitTime !== undefined) {
                    transitTime = Utils.toNum(rec.charges['Ocean Freight'].template.transitTime);
                }
            }
            for (let i = 0; i < chargelist.length; i++) {
                if (chargelist[i]['chargeDescription'] == 'Ocean Freight') {
                    let k = Object.keys(chargelist[i]);
                    for (let j = 0; j < k.length; j++) {
                        if (k[j].indexOf("perWM") != -1) {
                            perchargelable = k[j].split('perWM')[0];
                            Ocean_Freight_amount = chargelist[i][k[j]];
                            Ocean_Freight_currency = chargelist[i]['currency'];
                            break;
                        }
                    }
                }
            }
        }

        const getRouting = (ReWorkingPortName, POD, FPOD) => {
            const routing = ReWorkingPortName != undefined && ReWorkingPortName.length > 0 ? ReWorkingPortName : POD;
            if (routing !== FPOD) {
                return `${routing}`;
            } else {
                return `Direct`;
            }
        };
        let routing = getRouting(rep, pod, fpod);

        const convertCharges = (charges) => {
            return charges.map(item => {
                const curr = item.currency;
                const cbm = item.perCBM || 0;
                const ton = item.perTon || 0;
                const min = item.minimum || 0;
                const max = item.maximum || 0;
                const perBL = item.perShipment || 0;

                let CH = "";
                let displayLogic = "";

                const hasCBM = cbm != 0;
                const hasTon = ton != 0;
                const cbmEqualsTon = hasCBM && hasTon && cbm === ton;

                if (perBL != 0 && min === 0 && max != 0 && !hasCBM && !hasTon) {
                    CH = "CH9";
                }
                else if (perBL != 0 && min != 0 && max === 0 && !hasCBM && !hasTon) {
                    CH = "CH8";
                }
                else if (perBL != 0 && min === 0 && max === 0 && !hasCBM && !hasTon) {
                    CH = "CH7";
                }
                else if (hasCBM && hasTon && min === 0 && max === 0) {
                    CH = "CH1";
                }
                else if (hasCBM && !hasTon) {
                    CH = "CH2";
                }
                else if (!hasCBM && hasTon) {
                    CH = "CH3";
                }
                else if (hasCBM && hasTon && min > 0 && max === 0) {
                    CH = "CH4";
                }
                else if (hasCBM && hasTon && min != 0 && max != 0) {
                    CH = "CH5";
                }
                else if (hasCBM && hasTon && min === 0 && max != 0) {
                    CH = "CH6";
                }
                else {
                    CH = "CH1";
                }

                let wmLogic = "";

                if (hasCBM || hasTon) {
                    if (cbmEqualsTon) {
                        wmLogic = `${Utils.N(cbm, curr)} Per W/M`;
                    } 
                    else if (hasCBM && hasTon) {
                        wmLogic = `${Utils.N(cbm, curr)} Per CBM OR ${Utils.N(ton, curr)} Per Ton`;
                    } 
                    else if (hasCBM) {
                        wmLogic = `${Utils.N(cbm, curr)} Per CBM`;
                    } 
                    else {
                        wmLogic = `${Utils.N(ton, curr)} Per Ton`;
                    }
                }

                switch (CH) {
                    case "CH1":
                    case "CH2":
                    case "CH3":
                        displayLogic = wmLogic;
                        if (perBL !== 0) {
                            displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                        }
                        break;
                    case "CH4":
                        displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)}`;
                        break;
                    case "CH5":
                        displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)} AND Maximum ${Utils.N(max, curr)}`;
                        break;
                    case "CH6":
                        displayLogic = `${wmLogic}, Maximum ${Utils.N(max, curr)}`;
                        break;
                    case "CH7":
                        displayLogic = `${Utils.N(perBL, curr)} Per Bill of Lading`;
                        if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
                        break;
                    case "CH8":
                        displayLogic = `${Utils.N(min, curr)} Minimum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                        if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
                        break;
                    case "CH9":
                        displayLogic = `${Utils.N(max, curr)} Maximum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                        if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
                        break;
                }
                if(displayLogic.indexOf('Per Bill of Lading') == -1){
                    if(perBL != 0){
                        displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
                    }
                }

                return {
                    chargeDescription: item.chargeDescription,
                    remarks: item.remarks || "",
                    CH,
                    currency: curr,
                    perCBM: cbm || null,
                    perTon: ton || null,
                    minimum: min || null,
                    maximum: max || null,
                    perBL: perBL || null,
                    displayLogic
                };
            });
        };

        const convertChargesfcl = (containerList, charges) => {
            let l = [];
            containerList.map(e => {
                let ct = e.containerType;
                return charges.map(item => {
                    const curr = item.currency;
                    const perWM = item[ct + "perWM"] || 0;
                    const perShipment = item[ct + "perShipment"] || 0;

                    let CH = "";
                    let displayLogic = "";

                    const hasPerWM = perWM != 0;
                    const hasPerShipment = perShipment != 0;
                    const PerWMHavePerShipment = hasPerWM && hasPerShipment;

                    if (PerWMHavePerShipment) {
                        CH = "CH1";
                    }
                    else if (hasPerWM) {
                        CH = "CH2";
                    }
                    else if (hasPerShipment) {
                        CH = "CH3";
                    }

                    switch (CH) {
                        case "CH1":
                            displayLogic = `${Utils.N(perWM, curr)}  Per Container AND ${Utils.N(perShipment, curr)} Per BL`;
                            break;
                        case "CH2":
                            displayLogic = `${Utils.N(perWM, curr)}  Per Container`;
                            break;
                        case "CH3":
                            displayLogic = `${Utils.N(perShipment, curr)} Per BL`;
                            break;
                    }

                    l.push({
                        chargeDescription: item.chargeDescription + " - " + ct,
                        remarks: item.remarks || "",
                        CH,
                        currency: curr,
                        perWM: perWM || null,
                        perShipment: perShipment || null,
                        displayLogic
                    });
                });
            });
            return l;
        };

        let origincharges = [];
        let oceanFreightcharges = [];
        let Destinationcharges = [];
        let DestinationDescription = [];
        for (let i = 0; i < chargelist.length; i++) {
            let c = chargelist[i];
            if (c && c['chargeDescription'] != undefined) {
                let d = c['chargeDescription'];
                let cat = (c['category'] || '').toUpperCase();

                if (cat === 'ORIGIN') {
                    d = d.replace('Origin Charges - ', '');
                    d = d.replace('Origin - ', '');
                    d = d.replace('Origin Charges', '');
                    d = d.replace('Origin', '');
                    chargelist[i]['chargeDescription'] = d;
                    origincharges.push(chargelist[i]);
                }
                else if (cat === 'DESTINATION') {
                    d = d.replace('Destination Charges - ', '');
                    d = d.replace('Destination - ', '');
                    d = d.replace('Destination Charges', '');
                    d = d.replace('Destination', '');
                    chargelist[i]['chargeDescription'] = d;
                    if (d.length > 0) {
                        DestinationDescription.push(d);
                    }
                    Destinationcharges.push(chargelist[i]);
                }
                else if (cat === 'FREIGHT' || cat === 'OCEAN FREIGHT') {
                    oceanFreightcharges.push(chargelist[i]);
                }
            }
        }

        let Destinationchargestotal = {
            chargeDescription: "Destination",
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            perBL: 0,
            currency: "INR"
        };

        if (shipmentType.indexOf("FCL") != -1) {
            origincharges = convertChargesfcl(rec.dummyContract.containerList, origincharges);
            oceanFreightcharges = convertChargesfcl(rec.dummyContract.containerList, oceanFreightcharges);
            Destinationcharges = convertChargesfcl(rec.dummyContract.containerList, Destinationcharges);
        } else {
            for (let i = 0; i < Destinationcharges.length; i++) {
                let d = Destinationcharges[i];
                Destinationchargestotal['currency'] = Destinationcharges[0]['currency'];
                let k = ["perCBM", "perTon", "minimum", "maximum", "perBL"];
                k.map((e) => {
                    if (d[e] != undefined && d[e]) {
                        Destinationchargestotal[e] = Destinationchargestotal[e] + Number(d[e]);
                    }
                });
            }

            origincharges = convertCharges(origincharges);
            oceanFreightcharges = convertCharges(oceanFreightcharges);
            if (Destinationcharges.length > 0) {
                Destinationchargestotal = convertCharges([Destinationchargestotal]);
                Destinationcharges = convertCharges(Destinationcharges);
            }
        }

        let lines = [];

        // Header
        lines.push("*OCEAN FREIGHT RATE*");
        lines.push(`📍 ${origin} → ${destination}`);
        lines.push(`🚢 Routing: ${routing}`);

        if (shipmentType.indexOf("FCL") !== -1) {
            if (validtill) lines.push(`📅 Valid Till: ${validtill}`);
            if (carrier) lines.push(`🚢 Carrier: ${carrier}`);
            if (transitTime > 0) lines.push(`⏱ Ocean Transit Time: ${transitTime}`);
            if (Ocean_Freight_amount > 0) {
                lines.push(`💰 Ocean Freight (Per Container): ${Utils.N(Ocean_Freight_amount, Ocean_Freight_currency)} per ${perchargelable}`);
            }
        }

        // Ocean Freight
        if (oceanFreightcharges.length > 0) {
            lines.push("");
            lines.push("*OCEAN FREIGHT*");
            oceanFreightcharges.forEach(e => {
                lines.push(`• ${e.chargeDescription}: ${e.displayLogic}`);
                if (e.remarks && String(e.remarks).trim()) {
                    const rem = String(e.remarks).trim();
                    lines.push(`_(${rem})_`);
                }
            });
        }

        if (!copiedOceanFreight) {
            // Origin Charges
            if (origincharges.length > 0) {
                lines.push("");
                lines.push("*ORIGIN CHARGES*");
                origincharges.forEach(e => {
                    lines.push(`• ${e.chargeDescription}: ${e.displayLogic}`);
                    if (e.remarks && String(e.remarks).trim()) {
                        const rem = String(e.remarks).trim();
                        lines.push(`_(${rem})_`);
                    }
                });
            }

            // Destination Charges
            if (viewMode === "Detailed" && Destinationcharges.length > 0) {
                lines.push("");
                lines.push("*DESTINATION CHARGES*");
                Destinationcharges.forEach(e => {
                    lines.push(`• ${e.chargeDescription}: ${e.displayLogic}`);
                    if (e.remarks && String(e.remarks).trim()) {
                        const rem = String(e.remarks).trim();
                        lines.push(`_(${rem})_`);
                    }
                });
            } else if (viewMode === "Summary" && Destinationcharges.length > 0) {
                lines.push("");
                lines.push("*DESTINATION CHARGES - SUMMARY*");
                if (Destinationchargestotal[0]?.displayLogic) {
                    lines.push(`• Destination Charges Total: ${Destinationchargestotal[0].displayLogic}`);
                }
                if (DestinationDescription.length > 0) {
                    lines.push(`  Inclusive of ${DestinationDescription.join(", ")}`);
                }
            }
        }

        // Agent Details
        if (agentDetails.length > 0 || agentAddress.length > 0) {
            lines.push("");
            lines.push("*AGENT DETAILS*");
            if (agentDetails.length > 0) {
                lines.push(`🏢 ${agentDetails}`);
            }
            if (agentAddress.length > 0) {
                const addrLines = agentAddress.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
                addrLines.forEach(l => {
                    const isPhone = /^(\+?\d[\d\s\-\(\)]{5,}\d|phone|tel|mobile|fax)/i.test(l);
                    if (isPhone) {
                        lines.push(`📞 ${l}`);
                    } else {
                        lines.push(`📍 ${l}`);
                    }
                });
            }
        }

        // Terms & Conditions
        const numEmojis = ['1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];
        if (!copiedOceanFreight && tc.length > 0) {
            lines.push("");
            lines.push("*TERMS & CONDITIONS*");
            tc.forEach((e, i) => {
                const prefix = numEmojis[i] || `${i + 1}.`;
                lines.push(`${prefix} ${e}`);
            });
        } else if (copiedOceanFreight) {
            lines.push("");
            lines.push("*TERMS & CONDITIONS*");
            lines.push("1️⃣ Destination Charges are at Actual.");
            lines.push("2️⃣ Destination CFS Charges are at actuals.");
        }

        return lines.join("\n");
    };

    const copyElement = () => {
        if (isMobile) {
            const mobileText = buildMobileCopyText(prjs(editStore.pricingRec), false, view);
            copyTextToClipboard(mobileText);
            if (copied === false) {
                setCopied(true);
            }
            return;
        }

        const el = copyRef.current;
        if (!el) return alert("Element not found");

        const range = document.createRange();
        range.selectNodeContents(el);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        document.execCommand("copy");
        sel.removeAllRanges();
        if(copied==false){
            setCopied(true)
        }
    }

    const copyElement1 = () => {
        if (isMobile) {
            const mobileText = buildMobileCopyText(prjs(editStore.pricingRec), true, view);
            copyTextToClipboard(mobileText);
            if (copied === false) {
                setCopied(true);
            }
            return;
        }

        const el = copyRef1.current;
        if (!el) return alert("Element not found");

        const range = document.createRange();
        range.selectNodeContents(el);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        document.execCommand("copy");
        sel.removeAllRanges();
        if(copied==false){
            setCopied(true)
        }
    }

    return (
      <div>
        {isMobile && (
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: "12px",
            marginBottom: "12px",
            borderBottom: "1px solid #e2e8f0"
          }}>
            <span style={{ fontSize: "1.1rem", fontWeight: "700", color: "#1e3a8a" }}>
              Copy Mail
            </span>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenCopyMail && setOpenCopyMail(false);
              }}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "1.2rem",
                fontWeight: "bold",
                color: "#1e3a8a",
                cursor: "pointer",
                padding: "2px 8px"
              }}
            >
              ✕
            </button>
          </div>
        )}

        <Card pricingRec={prjs(editStore.pricingRec)} copiedOceanFreight={false} id={"1"} key={"1"}/>
        <Card pricingRec={prjs(editStore.pricingRec)} copiedOceanFreight={true} id={"2"} key={"2"}/>
        <br />
        
        {isMobile ? (
          <div style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            marginTop: "16px",
            paddingTop: "12px",
            borderTop: "1px solid #e2e8f0"
          }}>
            <button
              disabled={copied}
              className="button"
              style={{
                backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON || "#2b428c",
                color: "#fff",
                borderRadius: "6px",
                padding: "6px 16px",
                fontSize: "0.85rem",
                fontWeight: "600"
              }}
              onClick={async (e) => {
                e.preventDefault();
                copyElement();
                raiseRateRequest();
              }}
            >
              {copied ? "Copied" : "Copy"}
            </button>
            <button
              className="button"
              disabled={copied}
              style={{
                backgroundColor: "#1e293b",
                color: "#fff",
                borderRadius: "6px",
                padding: "6px 16px",
                fontSize: "0.85rem",
                fontWeight: "600"
              }}
              onClick={async (e) => {
                e.preventDefault();
                copyElement1();
                raiseRateRequest();
              }}
            >
              {copied ? "Copied Ocean Freight" : "Copy Ocean Freight"}
            </button>
          </div>
        ) : (
          <div className="columns is-vcentered is-multiline">
            <div className="column is-12" style={{ textAlign: "right" }}>
              <div
                className="field is-grouped"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div className="control">
                  <button
                    disabled={copied}
                    className="button"
                    style={{
                      backgroundColor:
                        process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                      color: "#fff",
                    }}
                    onClick={async (e) => {
                      copyElement();
                      raiseRateRequest();
                    }}
                  >
                    {copied ? "Copied" : "Copy"}
                  </button>
                </div>
                <div className="control">
                  <button
                    className="button"
                    disabled={copied}
                    style={{
                      backgroundColor:
                        process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                      color: "#fff",
                    }}
                    onClick={async (e) => {
                      copyElement1();
                      raiseRateRequest();
                    }}
                  >
                    {copied ? "Copied Ocean Freight" : "Copy Ocean Freight"}
                  </button>
                </div>
                <div className="control">
                  <button
                    className="button is-danger"
                    onClick={() => {
                      setOpenCopyMail(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
}